* {
  font-family: 'acumin-pro', Helvetica, Arial, sans-serif;
}

.container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.accordion {
  cursor: pointer;
  padding: 16px;
  text-align: left;
  font-size: 16px;
  font-weight: 700;
  outline: 0;
  text-transform: uppercase;
  color: #1b2d3a;
  border: none;
}

.accordion svg {
  float: right;
}

.open {
  display: block;
  height: auto;
  width: 200px;
  background-color: #f1f1f1;
}

p {
  padding: 0px 18px;
  margin-block: unset;
}

.close {
  display: none;
}
